import { IMotorcycleManualSearchSelection } from '@shared/types/IVehicleSelection';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';
import { VehicleRecord } from '@unified-commerce/gpc-vue-storefront-search';

const BASE_PARAMS = {
  resultsPerPage: 1,
};

const mergeFilters = (...filters: (string | undefined)[]) => {
  return filters.filter(Boolean).join(' AND ');
};

const hiddenFilter = (show: boolean) => `Hidden:${show}`;

const makeFilter = (make?: string) => [`Make:${make}`];

const modelFilter = ({
  submodel,
  model,
}: Pick<IMotorcycleManualSearchSelection, 'submodel' | 'model'>) => [
  `${submodel ? `Submodel:${submodel}` : `Model:${model}`}`,
];

const yearFilter = (year?: string) => `YearFrom <= ${year} AND YearTo >= ${year}`;

export const makeParams = () => ({
  ...BASE_PARAMS,
  facets: ['Make'],
  filters: hiddenFilter(false),
});

export const modelParams = ({ make }: IMotorcycleManualSearchSelection) => ({
  ...BASE_PARAMS,
  facets: ['Submodel', 'Model'],
  facetFilters: [makeFilter(make)],
  filters: hiddenFilter(false),
});

export const yearParams = ({ make, submodel, model }: IMotorcycleManualSearchSelection) => ({
  ...BASE_PARAMS,
  facets: ['YearFrom', 'YearTo'],
  facetFilters: [makeFilter(make), modelFilter({ submodel, model })],
  filters: hiddenFilter(false),
});

export const fullParams = ({ make, submodel, model, year }: IMotorcycleManualSearchSelection) => ({
  ...BASE_PARAMS,
  facets: ['YearFrom', 'YearTo'],
  hitsPerPage: undefined,
  facetFilters: [makeFilter(make), modelFilter({ submodel, model })],
  filters: mergeFilters(yearFilter(year), hiddenFilter(false)),
});

export const toPartsDbVehicleSummary = (record: VehicleRecord): PartsDbVehicleSummary => ({
  vehicleId: parseInt(record.VehicleID, 10),
  kTypeNr: parseInt(record.KtypNr, 10),
  make: record.Make,
  model: record.Model,
  submodel: record.Submodel,
  series: record.Series,
  yearFrom: Number(record.YearFrom),
  yearTo: Number(record.YearTo),
});
